import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-right",
  "use": "icon-arrow-right-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-arrow-right\">\n  <g fill=\"currentColor\" fill-rule=\"evenodd\">\n  <path d=\"M7.79 15.48l-1.06-1.06L11.15 10 6.73 5.58l1.06-1.06L13.27 10z\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol